var data = { header:{ text:"#### Warning",
    closeButton:true },
  body:{ text:"This test cannot be added as a re-requisition at no additional charge because it is in a \ndifferent clinical area or was not available at the time of the original order.\n\nIf you would like to order this test, please submit a new order, which will require a new \nspecimen and be billed as a separate test.\n\nFor more information, please visit our <a href=\"https://www.invitae.com/en/re-requisition/\" target=\"_blank\" rel=\"noopener noreferrer\">re-requisition</a> page or <a href=\"https://www.invitae.com/en/contact/\" target=\"_blank\" rel=\"noopener noreferrer\">contact</a> Client Services with any questions." },
  buttons:[ { text:"OK",
      isPrimary:true,
      action:"keepOrder" } ] };
data.header;
data.body;
data.buttons;

export { data as default };
//# sourceMappingURL=cross_assay_order.esm.js.map
